import AlertsContainer from '@shared/hooks/state/AlertsContainer';
import CurrentUserContainer from '@shared/hooks/state/CurrentUserContainer';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export default function useEmailVerificationResend() {
    const { showSuccess, showError } = AlertsContainer.useContainer();
    const { requestEmailVerificationResend } = CurrentUserContainer.useContainer();
    const { t } = useTranslation();

    const handleResendVerification = useCallback(async () => {
        try {
            const result = await requestEmailVerificationResend();
            if (result?.resultType === 'Ok') {
                showSuccess(t('common:account.isEmailVerified.success'));
            } else {
                showError(t('common:account.isEmailVerified.error'));
            }
        } catch (error) {
            showError(t('common:account.isEmailVerified.error'));
        }
    }, [t]);

    return { handleResendVerification };
}
